import * as React from 'react';
import * as info from "./style.module.scss"
export const Info = () => {
  return (
    <section className={info.info}>
      <div className="container">
        <div className={info.top}>
          <div className={info.vid}>
            <div className={info.bg}>
              <iframe src="https://www.youtube.com/embed/W0spQ7RiKtY?si=Mz5hqnkxUZIWXlTL&amp;controls=0" title={"Об Advance"} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen/>
            </div>
          </div>
          <ul className={info.topList}>
            <li><strong>Мы более 14 лет создаём образовательные программы</strong></li>
            <li>Наши технологии используют педагоги и ученики по всей России — от Петербурга до Камчатки</li>
            <li>98 школ, 2 вуза и 3 СПО внедрили наши технологии в систему образования</li>
            <li>Advance входит в список «100 лидеров новых подходов в образовании» и в перечень проектов, поддерживаемых АНО «Агентство стратегических инициатив» (АСИ)</li>
          </ul>
        </div>
        <ul className={info.bottomList}>
          <li>
            <p className={info.num}>1,7 млн</p>
            <p className={info.text}>человек знакомы<br/>с нами</p>
          </li>
          <li>
            <p className={info.num}>500 000</p>
            <p className={info.text}>подписчиков читают нас<br/>в соцсетях</p>
          </li>
          <li>
            <p className={info.num}>85 000</p>
            <p className={info.text}>учеников и 200+<br/>сотрудников<br/>доверяют нам</p>
          </li>
          <li>
            <p className={info.num}>16</p>
            <p className={info.text}>образовательных<br/>программ<br/>и более 50 мини-курсов</p>
          </li>
        </ul>
      </div>
    </section>
  );
}
